import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ProductGet } from '../../services';

export const fetchProductGet = createAsyncThunk(
    'productGet/fetchProductGet',
    async ({ id }) => {
        const response = await ProductGet(id)
        return response.result
    }
);

const productGetSlice = createSlice({
    name: 'productGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchProductGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchProductGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default productGetSlice.reducer;
